// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5443) return "static/chunks/ad7f724d-424c60e069174c19.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"6350":"9db6fdb4192bcf62","7856":"afb48b20b078498e","8483":"fa87fbdce4a8e945"}[chunkId] + ".js";
};